<template>
  <v-menu
    ref="menuDate"
    v-model="menuDate"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model.lazy="computedDateFormatted"
        v-bind="attrs"
        v-on="on"
        :label="label"
        :outlined="outlined"
        :rules="getRules"
        :placeholder="placeholder"
        :clearable="clearable"
        :prepend-icon="prependIcon"
        :append-icon-cb="(menu = true)"
        :disabled="disabled"
        :readonly="readonly"
        :dense="dense"
        v-mask="'##/##/####'"
        @click:clear="clear"
      />
    </template>
    <v-date-picker
      v-model="getValue"
      scrollable
      @input="menuDate = false"
      locale="pt-BR"
      :allowed-dates="allowedDatesMethod"
    />
  </v-menu>
</template>

<script>
import mixinInputDateFilter from '@/mixins/mixinInputDateFilter'

export default {
  name: 'InputDateFilter',
  mixins: [mixinInputDateFilter],
}
</script>
